import * as React from 'react';
import { withLocalize, LocalizeContextProps, Translate } from "react-localize-redux";
import bindAllOfThis from 'src/utils/BindThisHelper';
import Routes from "src/core/Routes";
import { Row, Col, Button } from "antd";
import DialogBox from "src/components/mission/DialogBox";
import { EnhancedProps } from 'src/pages/student/models/props';
import InfoBox from "src/components/mission/InfoBox";
import { Planets } from "src/constants/Planets";
import { Link } from "react-router-dom";
import { Grades } from "src/constants/Grades";

interface MissionLogProps extends EnhancedProps {
}

class MissionLog extends React.Component<MissionLogProps> {
    constructor(props: MissionLogProps) {
        super(props);
        bindAllOfThis(this, MissionLog.prototype);
    }

    onNextClick(): void {
        this.props.onNext();
    }

    renderCurrentBadges() {
        let planetImages = Planets.GetPlanetListByPlanetId(this.props.Mission.current.planetId).map(planet => (
            <img className="badge" alt="Planet Badge" src={planet.badgePath} key={`badge${planet.id}`} />
        ));
        return <div>{planetImages}</div>;
    }

    /**
     * Visible for grades 4+
     */
    renderTrainingAndEducationGuideButton() {
        if (this.props.currentGrade.level >= Grades.Fourth.level) {
            return <Link tabIndex={-1} to={Routes.getRoute(Routes.TRAINING_AND_EDUCATION_GUIDE, this.props.Mission.current.planetId)}>
                <Button tabIndex={1} size="small">
                    <Translate id="common.trainingAndEducation" />
                </Button>
            </Link>;
        }
    }

    /**
     * Visible for grades 3+
     */
    renderOccupationDb() {
        if (this.props.currentGrade.level >= Grades.Third.level) {
            return (<Link tabIndex={-1} to={Routes.OCCUPATIONDB}>
                <Button tabIndex={1} size="small">
                    <Translate id="public.occupationdb.title" />
                </Button>
            </Link>);
        }
    }

     /**
     * Visible for grades 3+
     */
    renderHollandGuideButton() {
        if (this.props.currentGrade.level >= Grades.Third.level) {
            return <Link tabIndex={-1} to={Routes.getRoute(Routes.HOLLAND_AREAS_GUIDE, this.props.Mission.current.planetId)}>
                <Button tabIndex={1} size="small">
                    <Translate id="common.hollandAreas" />
                </Button>
            </Link>;
        }
    }

    render() {
        this.props.onChangeAudio("");

        return <Row className="mission-log">
            <Col className="dialog-content" xs={{ span: 22, push: 1 }} md={{ span: 16 }} xl={14}>
                <DialogBox
                    currentGrade={this.props.currentGrade}
                    currentPlanet={this.props.currentPlanet}>
                    <h2><Translate id={"student.missionLog.header1"} /></h2>
                    <p><Translate id={"student.missionLog.body1"} /></p>
                    <Row>
                        <Col xs={12} xl={14} xxl={16}>
                            <h3><Translate id={"student.missionLog.header2"} /></h3>
                            {this.renderCurrentBadges()}
                            <br />
                            <Button autoFocus tabIndex={1} type="primary" size="large" onClick={this.onNextClick}>
                                <Translate id="student.missionLog.nextMission" />
                            </Button>
                        </Col>
                        <Col xs={12} xl={10} xxl={8}>
                            <h3><Translate id={"common.menu"} /></h3>
                            <div className="resource-buttons">
                                <Link tabIndex={-1} to={Routes.STATEMENTS}>
                                    <Button tabIndex={1} size="small">
                                        <Translate id="admin.sideNav.iStatementsText" />
                                    </Button>
                                </Link>
                                {this.renderOccupationDb()}
                                {this.renderHollandGuideButton()}
                                {this.renderTrainingAndEducationGuideButton()}
                            </div>
                        </Col>
                    </Row>
                </DialogBox>
            </Col>

            <Col xs={24} md={{ span: 7, push: 1 }} xl={9}>
                <Row type="flex" justify="space-between">
                    <Col xs={{ span: 23, push: 1 }} lg={{ span: 20, push: 4 }}>
                        <InfoBox currentGrade={this.props.currentGrade} currentPlanet={this.props.currentPlanet} />
                    </Col>
                </Row>
                <Row type="flex" justify="space-between">
                    <Col xs={{ span: 20, push: 2 }} lg={{ span: 21, push: 1 }}>
                        <img className="station-commander" alt={`Commander ${this.props.currentGrade.commander}`} src={this.props.currentGrade.commanderPath} height="100%" width="100%" />
                    </Col>
                </Row>
            </Col>
        </Row>;
    }
}

export default MissionLog;



// WEBPACK FOOTER //
// ./src/pages/student/scenes/MissionLog.tsx